import React from "react";

const Loading = ({ size = 48, color = "#ED1D24", label = "Carregando..." }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 50 50"
    role="status"
    aria-label={label}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={color}
      strokeOpacity="0.2"
      strokeWidth="5"
    />
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth="5"
      strokeLinecap="round"
      strokeDasharray="31.4 94.2"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.9s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export default Loading;